import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import RouteCard from "@/components/routes/RouteCard";

export default function RoutesList() {
  const { t, lang } = useLang();
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    document.title = `${t.routes.title} · Spain Luxury Rentals`;
    (async () => {
      try {
        const { data } = await api.get("/routes");
        setRoutes(data || []);
      } catch { /* ignore */ }
    })();
  }, [lang, t.routes.title]);

  return (
    <div className="bg-[#0C0C0C] pt-32 md:pt-40 pb-24" data-testid="routes-list-page">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-overline text-[#C9A55A] mb-4">{t.routes.kicker}</div>
        <h1 className="font-display text-[#F5F1EB] text-4xl md:text-6xl max-w-3xl">{t.routes.title}</h1>
        <p className="mt-5 text-[#F5F1EB]/70 font-light max-w-2xl">{t.routes.subtitle}</p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {routes.map((r, i) => <RouteCard key={r.id} route={r} index={i} />)}
        </div>
      </div>
    </div>
  );
}
